// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"337a977dcee633f5b81f","303":"4cc741211652a3507554","495":"1e1764b57e173056e437"}[chunkId] + ".js";
};